<script setup>
import {computed, Fragment, h} from "vue";
import CodeBox from "@/components/global/CodeBox.vue";
import InlineCode from "@/components/global/InlineCode.vue";
import ToggleSection from "@/components/onsiteEditor/components/installation/ToggleSection.vue";
import {useStore} from "vuex";

const props = defineProps({
  text: {
    type: [String, null],
    required: false,
    default: null,
  },
  websiteId: {
    type: Number,
    required: true,
  }
});

const store = useStore();
const cms = computed(() => store.getters['onsiteEditorInstallation/activeFilter']);

const getScriptTag = (manual) => {
  return `<script${['wordpress', 'elementor', 'woocommerce'].includes(cms.value) ? ' nowprocket nitro-exclude seraph-accel-crit="1"' : ''} data-cfasync="false" type="text/javascript" src="https://cdn.seoplatform.io/injector.js?websiteId=${props.websiteId}"${manual ? ' data-oso-manual' : '' }><`+`/script>`
}

const codeBlockContent = computed(() => getScriptTag())
const codeBlockInlineManual = computed(() => getScriptTag(true))
const codeBlockGlobalManual = computed(() => '<script>window._osoManualMode = true;<' + '/script> \n' + getScriptTag());

const renderParts = (text) => {
  return text.split(/(\[\[TOGGLE:.*?\]\][\s\S]*?\[\[\/TOGGLE\]\]|\[\[CODE\]\][\s\S]*?\[\[\/CODE\]\]|\[\[\w+\]\])/g).map((part) => {
     const toggleMatch = part.match(/^\[\[TOGGLE:(.*?)\]\]([\s\S]*)\[\[\/TOGGLE\]\]$/);

     if (toggleMatch) {
         return h(ToggleSection, { label: toggleMatch[1] }, () => renderParts(toggleMatch[2]));
     }

     const codeMatch = part.match(/^\[\[CODE\]\]([\s\S]*)\[\[\/CODE\]\]$/);

     if (codeMatch) {
         return h(CodeBox, { code: codeMatch[1] });
     }

     const tokenMatch = part.match(/^\[\[(\w+)\]\]$/);

     switch (tokenMatch?.[1]) {
         case 'CODE_BLOCK':
             return h(CodeBox, { code: codeBlockContent.value });
         case 'CODE_BLOCK_INLINE_MANUAL':
             return h(CodeBox, { code: codeBlockInlineManual.value });
         case 'CODE_BLOCK_GLOBAL_MANUAL':
             return h(CodeBox, { code: codeBlockGlobalManual.value });
         case 'WEBSITE_ID':
             return h(InlineCode, { code: props.websiteId });
         default:
             return h('span', { innerHTML: part });
     }
  });
};

const Result = {
  setup() {
    return () => h(Fragment, null, renderParts(props.text));
  }
}
</script>

<template>
  <div>
    <Result />
  </div>
</template>
